import Vue from 'vue' // Импортируем Vue
// import store from '@/store/index' // Импортируем Store
import axios from '@/plugins/axios'
import bus from '@/plugins/bus'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'
import VueCookies from 'vue-cookies'
import { BootstrapVue } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'


Vue.use(VueYoutube)
//Vue.use(VueCookie)
Vue.use(require('vue-cookies'))
Vue.use(BootstrapVue)
Vue.use(Vuelidate)

// Подключаем глобально компоненты
import components from '@/plugins/components'
components(Vue)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDTuckRDwxuLXSuAfoW8_D2Net7jMUT4Ic',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

/*
region: 'RU',
  language: 'ru'*/

Vue.config.productionTip = false // Отключаем предупреждение о режиме разработки

// Подключаем глобально стили
require('@/assets/css/style.scss')
require('@/assets/css/vuescroll.css')

// Подключаем Axios
Vue.prototype.$axios = axios

// Создаем event bus
Vue.prototype.$bus = bus

// Вшиваем в this Store
// Vue.prototype.$store = store

export default Vue
